<template>
  <div class="container mt-5">
    <vx-card>
      <vs-table
        stripe pagination
        :max-items="50"
        noDataText="No se encontraron resultados"
        :data="paymentProcessorTrxs">
        <div slot="header" class="ml-4 mt-2 mb-base flex items-center flex-grow justify-left">

          <div class="ml-6 flex">
            <vs-input
              @change="findOperations"
              label="Fecha inicio"
              type="date" v-model="startDate" />

            <vs-input
              @change="findOperations"
              label="Fecha fin"
              type="date"
              class="ml-5" v-model="endDate" />
          </div>

          <div class="ml-6">

          </div>

        </div>
        <template slot="thead">
          <vs-th>ID</vs-th>
          <vs-th>Procesador</vs-th>
          <vs-th>Estatus</vs-th>
          <vs-th>Motivo del reembolso</vs-th>
          <vs-th>F. Actualización</vs-th>
          <vs-th>Payload</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr v-for="p in data">
            <vs-td>{{ p.trx_id }}</vs-td>
            <vs-td>{{ p.payment_processor }}</vs-td>
            <vs-td>{{ p.status }}</vs-td>
            <vs-td>{{ p.refund_description }}</vs-td>
            <vs-td>{{ p.updated_at }}</vs-td>
            <vs-td>
              <vs-button class="small" @click="showPayloadViewer(p.payload)">
                Ver Payload
              </vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>

    <vs-popup title="Payload" :active.sync="showDialog">
      <pre v-if="payloadVisorData !== null">
        {{JSON.parse(payloadVisorData)}}
      </pre>
      <vs-alert color="warning" v-else>Sin información</vs-alert>
    </vs-popup>

  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "Index",
  data: () => ({
    paymentProcessorTrxs: [],
    startDate: '',
    endDate: '',
    showDialog: false,
    payloadVisorData: null
  }),
  async mounted() {
    this.startDate = moment().startOf('month').format("Y-MM-DD");
    this.endDate = moment().format("Y-MM-DD");

    await this.findOperations();
  },
  methods: {
    showPayloadViewer(payload) {
      this.showDialog = true;
      this.payloadVisorData = payload;
    },
    async findOperations() {
      const {data} = await axios.get(`/api/payment-processor-trx/failed?start_date=${this.startDate}&end_date=${this.endDate}`);
      this.paymentProcessorTrxs = data;
    }
  }
}
</script>

<style scoped>

</style>
